import { ExclamationCircleFilled } from '@ant-design/icons';
import { getRuntimeEnv } from '@utils/runtimeEnv';
import styles from './EnvironmentBanner.module.css';

interface EnvironmentBannerProps {
  /** Env var that enables this banner, e.g. REACT_APP_QA_ENV_BANNER_ENABLED. */
  enabledFlag: string;
  text: string;
}

/**
 * Non-production environment banner. Rendered only when the given
 * per-environment flag is 'true'; otherwise nothing is rendered.
 */
export default function EnvironmentBanner({ enabledFlag, text }: EnvironmentBannerProps) {
  const enabled = getRuntimeEnv(enabledFlag) === 'true';

  if (!enabled) {
    return null;
  }

  return (
    <div className={styles.banner} role="status" data-testid="environment-banner">
      <ExclamationCircleFilled className={styles.icon} aria-hidden="true" />
      <span>{text}</span>
    </div>
  );
}
